import { useSellPartiallyModal } from "@shared/features/trades/common/hooks";
import { displayResultMessage, openMessage } from "utils/misc";
import Modal from "common/Modal/Modal";
import Text from "common/Typography/Text";
import { TradeData } from "@shared/types";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import IconWithFallback from "Global/IconWithFallback";
import { ICON_TYPES } from "@shared/common/constants";
import ConnectedAmountPercentInputs from "common/Inputs/ConnectedAmountPercentInputs";
import React from "react";

interface SellPartiallyModalProps {
  tradeData?: TradeData;
  closeModal: () => void;
  isVisible?: boolean;
}

const SellPartiallyModal = ({
  tradeData,
  closeModal,
  isVisible,
}: SellPartiallyModalProps) => {
  const {
    title,
    onSubmit,
    actionIsLoading,
    description,
    contentIsLoading,
    quantityPrecision,
    maxPercent,
    quantity,
    setQuantity,
    isValid,
    quantityCoin,
    okText,
    errorMessage,
    availableQuantity,
    defaultPercent,
  } = useSellPartiallyModal({
    tradeData: isVisible ? tradeData : undefined,
    displayResultMessage,
    closeModal,
    openMessage,
  });

  const content = contentIsLoading ? (
    <LoadingSpinnerOverlay
      isLoading={true}
      wrap={true}
      wrapStyle={{ height: 30 }}
    />
  ) : (
    <>
      <Text>{description}</Text>
      <ConnectedAmountPercentInputs
        amountPrecision={quantityPrecision}
        percentPrecision={2}
        availableAmount={availableQuantity}
        amount={quantity === "0" ? undefined : quantity}
        defaultPercent={defaultPercent}
        onAmountChange={setQuantity}
        maxPercent={maxPercent}
        icon={
          <IconWithFallback
            iconType={ICON_TYPES.COIN}
            coinOrExchangeName={quantityCoin}
            iconStyle={{ marginRight: 4 }}
          />
        }
        showSlider={true}
      />
      {errorMessage && (
        <Text type="danger" style={{ marginTop: 12 }}>
          {errorMessage}
        </Text>
      )}
    </>
  );

  return (
    <Modal
      onCancel={closeModal}
      open={isVisible}
      title={title}
      onOk={onSubmit}
      okButtonProps={{ loading: actionIsLoading, disabled: !isValid }}
      okText={okText}
      destroyOnHidden={true}
    >
      {content}
    </Modal>
  );
};

export default React.memo(SellPartiallyModal);
